// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInDays as fn } from "../differenceInDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInDaysWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInDaysWithOptions;
